export default __webpack_public_path__ + "static/gmg-background-video-ec7bc55c86d5fc2cc4574b46f915ece7.mp4";